import React from "react";

const ListeDepenses = () => {
  return (
    <div className="liste-depenses">
      <h2>Liste des dépenses</h2>
      <p>Affiche la liste des dépenses enregistrées.</p>
    </div>
  );
};

export default ListeDepenses;
